import React from 'react';
import Cropper from 'react-easy-crop';
import { Typography, Slider, Empty } from 'antd';
import {
  useCropBlockActions,
  useCropBlockState,
} from '../../features/cropBlock';
import styles from './CropperBlock.module.scss';

const { Text } = Typography;

const CropperBlock = () => {
  const { fileSrc, aspect, crop, zoom, initialCroppedArea, height, hasZoom } =
    useCropBlockState();

  const { onZoomChange, onCropChange, onCropComplete, onMediaLoaded } =
    useCropBlockActions();

  return fileSrc ? (
    <>
      <div
        className={styles.cropContainer}
        style={{ height: height || '600px' }}
      >
        <Cropper
          image={fileSrc}
          crop={crop}
          zoom={zoom}
          aspect={aspect}
          showGrid={false}
          onCropChange={onCropChange}
          onCropComplete={onCropComplete}
          onZoomChange={hasZoom ? onZoomChange : undefined}
          initialCroppedAreaPixels={initialCroppedArea}
          onMediaLoaded={onMediaLoaded}
          objectFit="horizontal-cover"
        />
      </div>

      {hasZoom && (
        <div className={styles.sliderContainer}>
          <Text className={styles.sliderTitle}>Масштабирование</Text>
          <Slider
            value={zoom}
            min={1}
            max={3}
            step={0.1}
            className={styles.slider}
            onChange={onZoomChange}
          />
        </div>
      )}
    </>
  ) : (
    <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
  );
};

export default CropperBlock;
